if (!customElements.get('custom-reviews')) {
    class CustomReviews extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.mySwiper = null;
        }

        connectedCallback() {
            const scrollBar = this.querySelector('.swiper-scrollbar');
            this.mySwiper = new Swiper(this.swiper, {
                slidesPerView: 3,
                spaceBetween: 25,
                scrollbar: {
                    el: scrollBar || null,
                    draggable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    },
                    591: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1001: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                    }
                }
            })
        }
    }

    customElements.define('custom-reviews', CustomReviews);
}
